<app-loading *ngIf="contentReady"></app-loading>

<div
  class="bbm-page clinic-opening-hours-mobile-page"
  [class.rtl]="isAr"
  [dir]="isAr ? 'rtl' : 'ltr'"
  *ngIf="!contentReady"
>
  <div class="bbm-shell">

    <!-- HERO -->
    <section class="bbm-hero">

      <div class="bbm-hero-top">

        <div class="bbm-main-info">

          <div class="bbm-avatar">
            <i class="fa-regular fa-calendar-days"></i>
          </div>

          <div class="bbm-hero-copy">
            <span class="bbm-eyebrow">
              {{ 'clinicAppointments.title' | transloco }}
            </span>

            <h2>
              {{ 'clinicAppointments.title' | transloco }}
            </h2>

            <p>
              {{ 'clinicAppointments.business' | transloco }}:
              <strong>
                {{ selectedBusinessName || '—' }}
              </strong>
            </p>
          </div>

        </div>

        <div class="bbm-hero-counter">
          <strong>
            {{ savedSchedule?.length || 0 }}
          </strong>

          <span>
            {{ 'clinicAppointments.title' | transloco }}
          </span>
        </div>

      </div>

      <div
        class="bbm-actions-grid bbm-hero-actions noPrint"
        *ngIf="hasSavedSchedule && viewMode === 'table'"
      >
        <button
          type="button"
          class="bbm-action-btn bbm-action-primary bbm-action-wide"
          (click)="openFormForEdit()"
        >
          <i class="fa-regular fa-pen-to-square"></i>

          <span>
            {{ 'clinicAppointments.edit' | transloco }}
          </span>
        </button>
      </div>

    </section>

    <!-- SERVER ERROR -->
    <div
      class="bbm-alert bbm-alert-danger"
      *ngIf="serverError"
      role="alert"
    >
      <i class="fa-solid fa-circle-exclamation"></i>

      <span>
        {{ serverError }}
      </span>
    </div>

    <!-- SAVED SCHEDULE -->
    <section
      class="bbm-schedule-list"
      *ngIf="viewMode === 'table'"
    >
      <article
        class="bbm-ticket bbm-schedule-card"
        [class.bbm-ticket-success]="day.enabled && day.shifts.length"
        [class.is-disabled]="!day.enabled || !day.shifts.length"
        *ngFor="
          let day of savedSchedule;
          trackBy: trackByDay
        "
      >

        <div class="bbm-ticket-top">

          <div class="bbm-main-info">

            <div class="bbm-avatar">
              <i
                class="fa-regular"
                [class.fa-calendar-check]="
                  day.enabled && day.shifts.length
                "
                [class.fa-calendar-xmark]="
                  !day.enabled || !day.shifts.length
                "
              ></i>
            </div>

            <div class="bbm-copy">
              <span>
                {{ 'clinicAppointments.title' | transloco }}
              </span>

              <h3>
                {{
                  (
                    'clinicAppointments.days.' +
                    day.day
                  ) | transloco
                }}
              </h3>

              <p>
                {{
                  day.enabled
                    ? ('clinicAppointments.openDay' | transloco)
                    : ('clinicAppointments.closedDay' | transloco)
                }}
              </p>
            </div>

          </div>

          <span
            class="bbm-status-pill"
            [class.bbm-status-success]="
              day.enabled && day.shifts.length
            "
            [class.bbm-status-danger]="
              !day.enabled || !day.shifts.length
            "
          >
            <ng-container
              *ngIf="
                day.enabled &&
                day.shifts.length;
                else closedState
              "
            >
              <i class="fa-solid fa-check"></i>

              {{ 'clinicAppointments.openDay' | transloco }}
            </ng-container>

            <ng-template #closedState>
              <i class="fa-solid fa-xmark"></i>

              {{ 'clinicAppointments.closed' | transloco }}
            </ng-template>
          </span>

        </div>

        <!-- SHIFTS -->
        <div
          class="bbm-shift-preview"
          *ngIf="day.enabled && day.shifts.length"
        >
          <span
            class="bbm-shift-pill"
            *ngFor="
              let shift of day.shifts;
              trackBy: trackByShift
            "
          >
            <i class="fa-regular fa-clock"></i>

            <span>
              {{ formatShiftText(shift) }}
            </span>
          </span>
        </div>

        <!-- CLOSED DAY -->
        <div
          class="bbm-disabled-panel"
          *ngIf="!day.enabled"
        >
          <i class="fa-regular fa-calendar-xmark"></i>

          <span>
            {{ 'clinicAppointments.dayClosedHint' | transloco }}
          </span>
        </div>

        <!-- NOT CONFIGURED -->
        <div
          class="bbm-disabled-panel"
          *ngIf="day.enabled && !day.shifts.length"
        >
          <i class="fa-regular fa-clock"></i>

          <span>
            {{ 'clinicAppointments.notConfigured' | transloco }}
          </span>
        </div>

      </article>
    </section>

    <!-- CREATE / EDIT FORM -->
    <form
      *ngIf="viewMode === 'form'"
      (ngSubmit)="onSubmit()"
    >

      <!-- SETUP HINT -->
      <section class="bbm-form-ticket">

        <div class="bbm-main-info">

          <div class="bbm-avatar">
            <i class="fa-solid fa-calendar-check"></i>
          </div>

          <div class="bbm-copy">
            <span>
              {{ 'clinicAppointments.title' | transloco }}
            </span>

            <h3>
              {{
                hasSavedSchedule
                  ? (
                      'clinicAppointments.editRegularSchedule'
                      | transloco
                    )
                  : (
                      'clinicAppointments.setOpeningTimes'
                      | transloco
                    )
              }}
            </h3>

            <p>
              {{ 'clinicAppointments.mobileHint' | transloco }}
            </p>
          </div>

        </div>

      </section>

      <!-- VALIDATION ALERT -->
      <div
        class="bbm-alert bbm-alert-danger"
        *ngIf="submitted && !isScheduleValid()"
        role="alert"
      >
        <i class="fa-solid fa-circle-exclamation"></i>

        <span>
          {{
            'clinicAppointments.validation.reviewSchedule'
              | transloco
          }}
        </span>
      </div>

      <!-- DAYS EDITOR -->
      <section class="bbm-schedule-list">

        <article
          class="bbm-ticket bbm-schedule-card"
          [class.bbm-ticket-success]="day.enabled"
          [class.is-disabled]="!day.enabled"
          [class.is-error]="hasDayError(day)"
          *ngFor="
            let day of draftSchedule;
            trackBy: trackByDay
          "
        >

          <!-- DAY HEADER -->
          <div class="bbm-ticket-top">

            <div class="bbm-main-info">

              <div class="bbm-avatar">
                <i
                  class="fa-regular"
                  [class.fa-calendar-check]="day.enabled"
                  [class.fa-calendar-xmark]="!day.enabled"
                ></i>
              </div>

              <div class="bbm-copy">
                <span>
                  {{ 'clinicAppointments.title' | transloco }}
                </span>

                <h3>
                  {{
                    (
                      'clinicAppointments.days.' +
                      day.day
                    ) | transloco
                  }}
                </h3>

                <p>
                  {{
                    day.enabled
                      ? (
                          'clinicAppointments.openDay'
                          | transloco
                        )
                      : (
                          'clinicAppointments.closedDay'
                          | transloco
                        )
                  }}
                </p>
              </div>

            </div>

            <label class="bbm-switch">
              <input
                type="checkbox"
                [checked]="day.enabled"
                (change)="toggleDay(day)"
              >

              <span class="bbm-switch-track"></span>
            </label>

          </div>

          <!-- ENABLED DAY SHIFTS -->
          <div
            class="bbm-shifts-editor"
            *ngIf="day.enabled"
          >

            <div
              class="bbm-shift-editor-row"
              *ngFor="
                let shift of day.shifts;
                let i = index;
                trackBy: trackByShift
              "
            >

              <!-- OPEN TIME -->
              <div class="bbm-time-field">
                <label>
                  {{ 'clinicAppointments.openAt' | transloco }}
                </label>

                <div class="bbm-time-picker">

                  <select
                    [value]="getTimeHour12(shift.start)"
                    (change)="
                      updateArabicTimePart(
                        day,
                        i,
                        'start',
                        'hour',
                        $event
                      )
                    "
                  >
                    <option
                      *ngFor="let hour of hourOptions"
                      [value]="hour"
                    >
                      {{ getTimeOptionLabel(hour) }}
                    </option>
                  </select>

                  <span>:</span>

                  <select
                    [value]="getTimeMinute(shift.start)"
                    (change)="
                      updateArabicTimePart(
                        day,
                        i,
                        'start',
                        'minute',
                        $event
                      )
                    "
                  >
                    <option
                      *ngFor="let minute of minuteOptions"
                      [value]="minute"
                    >
                      {{ getTimeOptionLabel(minute) }}
                    </option>
                  </select>

                  <select
                    [value]="getTimePeriod(shift.start)"
                    (change)="
                      updateArabicTimePart(
                        day,
                        i,
                        'start',
                        'period',
                        $event
                      )
                    "
                  >
                    <option value="am">
                      {{ getPeriodOptionLabel('am') }}
                    </option>

                    <option value="pm">
                      {{ getPeriodOptionLabel('pm') }}
                    </option>
                  </select>

                </div>

                <small
                  class="bbm-time-preview"
                  *ngIf="isAr"
                >
                  {{ formatTime(shift.start) }}
                </small>
              </div>

              <!-- CLOSE TIME -->
              <div class="bbm-time-field">
                <label>
                  {{ 'clinicAppointments.closeAt' | transloco }}
                </label>

                <div class="bbm-time-picker">

                  <select
                    [value]="getTimeHour12(shift.end)"
                    (change)="
                      updateArabicTimePart(
                        day,
                        i,
                        'end',
                        'hour',
                        $event
                      )
                    "
                  >
                    <option
                      *ngFor="let hour of hourOptions"
                      [value]="hour"
                    >
                      {{ getTimeOptionLabel(hour) }}
                    </option>
                  </select>

                  <span>:</span>

                  <select
                    [value]="getTimeMinute(shift.end)"
                    (change)="
                      updateArabicTimePart(
                        day,
                        i,
                        'end',
                        'minute',
                        $event
                      )
                    "
                  >
                    <option
                      *ngFor="let minute of minuteOptions"
                      [value]="minute"
                    >
                      {{ getTimeOptionLabel(minute) }}
                    </option>
                  </select>

                  <select
                    [value]="getTimePeriod(shift.end)"
                    (change)="
                      updateArabicTimePart(
                        day,
                        i,
                        'end',
                        'period',
                        $event
                      )
                    "
                  >
                    <option value="am">
                      {{ getPeriodOptionLabel('am') }}
                    </option>

                    <option value="pm">
                      {{ getPeriodOptionLabel('pm') }}
                    </option>
                  </select>

                </div>

                <small
                  class="bbm-time-preview"
                  *ngIf="isAr"
                >
                  {{ formatTime(shift.end) }}
                </small>
              </div>

              <!-- DELETE SHIFT -->
              <button
                type="button"
                class="bbm-action-btn bbm-action-danger bbm-icon-action"
                (click)="removeShift(day, i)"
              >
                <i class="fa-regular fa-trash-can"></i>
              </button>

              <!-- OVERNIGHT -->
              <div
                class="bbm-overnight-note"
                *ngIf="isOvernightShift(shift)"
              >
                <i class="fa-regular fa-moon"></i>

                <span>
                  {{ 'clinicAppointments.nextDay' | transloco }}
                </span>
              </div>

            </div>

            <!-- DAY ERROR -->
            <div
              class="bbm-field-error"
              *ngIf="hasDayError(day)"
            >
              {{
                'clinicAppointments.validation.dayTimeRequired'
                  | transloco
              }}
            </div>

            <!-- ADD SHIFT -->
            <button
              type="button"
              class="bbm-action-btn bbm-action-primary bbm-action-wide"
              (click)="addShift(day)"
            >
              <i class="fa-solid fa-plus"></i>

              <span>
                {{ 'clinicAppointments.addShift' | transloco }}
              </span>
            </button>

          </div>

          <!-- DISABLED DAY -->
          <div
            class="bbm-disabled-panel"
            *ngIf="!day.enabled"
          >
            <i class="fa-regular fa-calendar-xmark"></i>

            <span>
              {{ 'clinicAppointments.dayClosedHint' | transloco }}
            </span>
          </div>

        </article>

      </section>

      <!-- BOTTOM ACTIONS -->
      <div class="bbm-sticky-actions noPrint">
        <div class="bbm-actions-grid">

          <button
            *ngIf="hasSavedSchedule"
            type="button"
            class="bbm-action-btn bbm-action-warning"
            (click)="cancelEdit()"
          >
            <i class="fa-solid fa-arrow-rotate-left"></i>

            <span>
              {{ 'clinicAppointments.cancel' | transloco }}
            </span>
          </button>

          <button
            type="submit"
            class="bbm-action-btn bbm-action-primary"
            [class.bbm-action-wide]="!hasSavedSchedule"
            [disabled]="saving"
          >
            <ng-container *ngIf="saving; else saveText">
              <span
                class="bbm-loader-spinner"
                aria-hidden="true"
              ></span>

              <span>
                {{ 'clinicAppointments.saving' | transloco }}
              </span>
            </ng-container>

            <ng-template #saveText>
              <i class="fa-solid fa-check"></i>

              <span>
                {{ 'clinicAppointments.submit' | transloco }}
              </span>
            </ng-template>
          </button>

        </div>
      </div>

    </form>

  </div>
</div>